import React, { useState } from "react";
import { Nav, Tab } from "react-bootstrap";
import "./History_Inner_Page.css";
import History_Vendor from "../history-vendor/History_Vendor";
import History_Expert from "../history-expert/History_Expert";
import Expert_Tab_History from "../Expert-Tab_History/Expert_Tab_History";
import Vendor_Tab_History from "../Vendor-Tab-History/Vendor_Tab_History";
function History_Inner_Page() {
  const [activeTab, setActiveTab] = useState("vendors");
  return (
    <section className="vendor-expert-section">
      <div className="container">
        <Tab.Container activeKey={activeTab} onSelect={(k) => setActiveTab(k)}>
          <div className="vendor-expert-header">
            <Nav variant="pills" className="vendor-expert-tabs">
              <Nav.Item>
                <Nav.Link eventKey="vendors">Vendors</Nav.Link>
              </Nav.Item>
              <Nav.Item>
                <Nav.Link eventKey="experts">Experts</Nav.Link>
              </Nav.Item>
            </Nav>
          </div>
          <Tab.Content className="mt-4">
            <Tab.Pane eventKey="vendors">
              <History_Vendor />
            </Tab.Pane>
            <Tab.Pane eventKey="experts">
              <History_Expert />
              <div className="text-center"></div>
            </Tab.Pane>
          </Tab.Content>
        </Tab.Container>
      </div>
      <Expert_Tab_History />
      <Vendor_Tab_History />
    </section>
  );
}
export default History_Inner_Page;
